import React from 'react'
import styled from 'styled-components'

const StyledRow = styled.div`
  ${({ position }) => position && { position }};
  ${({ width }) => width && { width }};
  ${({ margin }) => margin && { margin }};
  ${({ padding }) => padding && { padding }};
  ${({ color }) => color && { color }};
  ${({ boxShadow }) => boxShadow && `box-shadow: ${boxShadow}`}};
  ${({ background }) => background && background};
  ${({ align }) => align && `align-items: ${align}`};
  ${({ justify }) => justify && `justify-content: ${justify}`};
  ${({ wrap }) => wrap && `flex-wrap: ${wrap}`};
  display: flex;
  flex-direction: row;
  img {
    max-width: 100%;
  }

`

const Row = ({
  width = '100%',
  children,
  background,
  boxShadow,
  color,
  align = 'center',
  justify,
  wrap = 'wrap',
  margin,
  padding,
  position,
}) => (
  <StyledRow
    align={align}
    background={background}
    boxShadow={boxShadow}
    color={color}
    justify={justify}
    margin={margin}
    padding={padding}
    position={position}
    width={width}
    wrap={wrap}
  >
    {children}
  </StyledRow>
)

export default Row
